module.exports = __webpack_public_path__ + "img/bw.ad6b46a4.svg";